<template>
    <DashboadCard>
        <div class="ranking">
            <div class="ranking__header">
                <DashboardIcon icon="star" color="#F1B44C" />
                <div class="ranking__header-texts">
                    <div class="ranking__title">Top Clientes Frecuentes</div>
                    <div class="ranking__subtitle">Clientes con más pedidos en el período</div>
                </div>
            </div>
            <div class="ranking__list">
                <div v-for="(client, index) in clients" :key="index" class="ranking__item">
                    <div class="ranking__position">{{ client.position }}</div>
                    <div class="ranking__avatar" :style="{ backgroundColor: client.avatarColor }">
                        {{ client.initials }}
                    </div>
                    <div class="ranking__info">
                        <div class="ranking__name">{{ client.name }}</div>
                        <div class="ranking__time">{{ client.lastOrder }}</div>
                    </div>
                    <div class="ranking__count">{{ client.orders }}</div>
                </div>
            </div>
            <div v-if="totalPages > 1" class="ranking__pagination">
                <button class="ranking__page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">
                    <i class="material-icons">chevron_left</i>
                </button>
                <span class="ranking__page-info">{{ currentPage }} / {{ totalPages }}</span>
                <button class="ranking__page-btn" :disabled="currentPage >= totalPages"
                    @click="changePage(currentPage + 1)">
                    <i class="material-icons">chevron_right</i>
                </button>
            </div>
        </div>
    </DashboadCard>
</template>

<script>
import DashboadCard from './DashboadCard.vue';
import DashboardIcon from './DashboardIcon.vue';
import { mapGetters, mapActions } from 'vuex';

const AVATAR_COLORS = ['#34C38F', '#50A5F1', '#F1B44C', '#F46A6A', '#556EE6', '#74788D', '#343A40'];

export default {
    name: 'TopCustomersRanking',
    components: {
        DashboadCard,
        DashboardIcon
    },
    computed: {
        ...mapGetters(['topFrequentCustomers', 'dashboardFilters']),
        currentPage() {
            return this.topFrequentCustomers?.page || 1;
        },
        totalPages() {
            return this.topFrequentCustomers?.totalPages || 1;
        },
        clients() {
            return (this.topFrequentCustomers?.customers || []).map((customer, index) => ({
                position: customer.position,
                initials: this.getInitials(customer.name),
                name: customer.name,
                lastOrder: this.formatRelativeDate(customer.lastOrderDate),
                orders: customer.orders,
                avatarColor: AVATAR_COLORS[index % AVATAR_COLORS.length]
            }));
        }
    },
    methods: {
        ...mapActions(['fetchTopFrequentCustomers']),
        getInitials(name) {
            if (!name) return '??';
            const words = name.trim().split(/\s+/);
            if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
            return (words[0][0] + words[1][0]).toUpperCase();
        },
        formatRelativeDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            const now = new Date();
            const diffMs = now - date;
            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            if (diffDays === 0) return 'Hoy';
            if (diffDays === 1) return 'Ayer';
            return `Hace ${diffDays} días`;
        },
        changePage(page) {
            this.fetchTopFrequentCustomers({
                page,
                ...this.dashboardFilters
            });
        }
    }
}
</script>

<style scoped>
.ranking {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.ranking__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.ranking__header-texts {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.ranking__title {
    font-size: 0.95rem;
    font-weight: 600;
}

.ranking__subtitle {
    font-size: 0.8rem;
    opacity: 0.6;
}

.ranking__list {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.ranking__item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.ranking__item:last-child {
    border-bottom: none;
}

.ranking__position {
    font-size: 0.8rem;
    font-weight: 700;
    color: #999;
    width: 16px;
    text-align: center;
}

.ranking__avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 600;
    color: #fff;
    flex-shrink: 0;
}

.ranking__info {
    flex: 1;
    min-width: 0;
}

.ranking__name {
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ranking__time {
    font-size: 0.75rem;
    opacity: 0.5;
}

.ranking__count {
    font-size: 1.1rem;
    font-weight: 700;
    color: #333;
}

.ranking__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 0.75rem;
    padding-top: 0.5rem;
    border-top: 1px solid #f0f0f0;
}

.ranking__page-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 1px solid #dce2e8;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    color: #333;
    transition: all 0.15s ease;
}

.ranking__page-btn:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #ccc;
}

.ranking__page-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.ranking__page-btn i {
    font-size: 18px;
}

.ranking__page-info {
    font-size: 0.8rem;
    color: #666;
    font-weight: 500;
}
</style>
